/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-closing-bracket-location */
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { withTranslation } from 'react-i18next';
import { FormHelperText } from '@material-ui/core';

import { formValidator } from '../../../AppUtil/AppUtil';
import { commonStyleForEditPersonalInfo } from '../../Common/CommonStyle';
import BaseForm from './BaseForm';
import { Autocomplete } from '@material-ui/lab';

class CreateBankAccountForm extends React.Component {
	constructor(props) {
		super(props);
		this.accounTypes = [
			{ label: 'Checking', value: 'CH' },
			{ label: 'Current', value: 'CU' },
			{ label: 'Digital', value: 'DI' },
			{ label: 'Saving', value: 'SA' }
		];
		this.state = {
			_disableSaveButton: true,
			_bankAccountForm: {
				accountName: {
					value: this.props.user.name,
					placeholder: 'Account Name',
					isValid: true,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'Account name is required'
						}
					},
					error_text: ''
				},
				accountNumber: {
					value: '',
					placeholder: 'Account Number',
					isValid: true,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'Account number is required'
						}
					},
					error_text: ''
				},
				bank: {
					value: '',
					placeholder: 'Bank',
					isValid: true,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'Bank is required'
						}
					},
					error_text: ''
				},
				accountType: {
					value: '',
					placeholder: 'Account Type',
					isValid: true,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'Account type is required'
						}
					},
					error_text: ''
				}
			}
		};
	}

	handleInputChange = e => {
		this.setState({
			_disableSaveButton: false
		});
		const name = e.target.name;
		const value = e.target.value;
		const bankAccountForm = {
			...this.state._bankAccountForm
		};
		const updatedFormElement = {
			...bankAccountForm[name]
		};
		updatedFormElement.value = value;
		updatedFormElement.isValid = true;
		updatedFormElement.error_text = '';
		bankAccountForm[name] = updatedFormElement;
		this.setState({
			_bankAccountForm: bankAccountForm
		});
	};

	handleDropdownChange = (e, name, value) => {
		this.setState({
			_disableSaveButton: false
		});
		const bankAccountForm = {
			...this.state._bankAccountForm
		};
		const updatedFormElement = {
			...bankAccountForm[name]
		};
		updatedFormElement.value = value;
		updatedFormElement.isValid = true;
		updatedFormElement.error_text = '';
		bankAccountForm[name] = updatedFormElement;
		this.setState({
			_bankAccountForm: bankAccountForm
		});
	};

	formValidator = () => {
		const form = {
			...this.state._bankAccountForm
		};
		let [updatedForm, isFormValid] = formValidator(form);
		this.setState({
			_bankAccountForm: updatedForm
		});
		return isFormValid;
	};

	onSubmitHandler = e => {
		e.preventDefault();
		if (!this.formValidator()) {
			return false;
		}
		const bankAccountForm = {
			...this.state._bankAccountForm
		};
		const bankAccountObj = {
			sub_email: this.props.user.email,
			account_name: bankAccountForm.accountName.value,
			account_number: bankAccountForm.accountNumber.value,
			bank: bankAccountForm.bank.value.value,
			account_type: bankAccountForm.accountType.value.value
		};
		this.props.onSubmit(bankAccountObj);
	};

	render() {
		const { classes, t, bankOptions, isLoading, closeProfileScreen } =
			this.props;
		const { _bankAccountForm, _disableSaveButton } = this.state;

		return (
			<BaseForm
				closeProfileScreen={closeProfileScreen}
				disabled={_disableSaveButton}
				isLoading={isLoading}
				onSubmitHandler={this.onSubmitHandler}
			>
				<Grid alignItems='center' item justify='center' sm={12} xs={12}>
					<Typography component='h1' variant='h5'>
						{t('profile.add_bank_account')}
					</Typography>
				</Grid>
				<Grid alignItems='center' item justify='center' sm={8} xs={12}>
					<TextField
						autoComplete='accountName'
						className={classes.displayFlex}
						error={
							!_bankAccountForm.accountName.isValid &&
							_bankAccountForm.accountName.isTouched
						}
						fullWidth
						helperText={
							!_bankAccountForm.accountName.isValid &&
							_bankAccountForm.accountName.isTouched
								? t(_bankAccountForm.accountName.error_text)
								: ''
						}
						id='accountName'
						label='Account Name'
						name='accountName'
						onChange={this.handleInputChange}
						required
						type='text'
						value={_bankAccountForm.accountName.value}
						variant='outlined'
					/>
				</Grid>
				<Grid alignItems='center' item justify='center' sm={8} xs={12}>
					<TextField
						autoComplete='accountNumber'
						className={classes.displayFlex}
						error={
							!_bankAccountForm.accountNumber.isValid &&
							_bankAccountForm.accountNumber.isTouched
						}
						fullWidth
						helperText={
							!_bankAccountForm.accountNumber.isValid &&
							_bankAccountForm.accountNumber.isTouched
								? t(_bankAccountForm.accountNumber.error_text)
								: ''
						}
						id='accountNumber'
						label='Account Number'
						name='accountNumber'
						onChange={this.handleInputChange}
						required
						type='number'
						value={_bankAccountForm.accountNumber.value}
						variant='outlined'
					/>
				</Grid>
				<Grid alignItems='center' item justify='center' sm={8} xs={12}>
					<Autocomplete
						error={
							!_bankAccountForm.bank.isValid &&
							_bankAccountForm.bank.isTouched
						}
						fullwidth
						getOptionLabel={option => option.label || ''}
						id='bank'
						name='bank'
						onChange={(event, value) =>
							this.handleDropdownChange(event, 'bank', value)
						}
						options={bankOptions}
						renderInput={params => (
							<TextField
								{...params}
								label={t(_bankAccountForm.bank.placeholder)}
								name='bank'
								variant='outlined'
						        required
								error={
									!this.state._bankAccountForm.bank.isValid &&
									this.state._bankAccountForm.bank.isTouched
								}
							/>
						)}
						value={_bankAccountForm.bank.value}
					/>
					{!_bankAccountForm.bank.isValid &&
					_bankAccountForm.bank.isTouched ? (
						<FormHelperText
							id='text-red'
							style={{ margin: '-10px 15px 10px' }}
						>
							{t(_bankAccountForm.bank.error_text)}
						</FormHelperText>
					) : (
						''
					)}
				</Grid>
				<Grid alignItems='center' item justify='center' sm={8} xs={12}>
					<Autocomplete
						error={
							!_bankAccountForm.accountType.isValid &&
							_bankAccountForm.accountType.isTouched
						}
						fullwidth
						getOptionLabel={option => option.label || ''}
						id='accountType'
						name='accountType'
						onChange={(event, value) =>
							this.handleDropdownChange(event, 'accountType', value)
						}
						options={this.accounTypes}
						renderInput={params => (
							<TextField
								{...params}
								label={t(_bankAccountForm.accountType.placeholder)}
								name='accountType'
								variant='outlined'
						        required
								error={
									!this.state._bankAccountForm.accountType.isValid &&
									this.state._bankAccountForm.accountType.isTouched
								}
							/>
						)}
						value={_bankAccountForm.accountType.value}
					/>
					{!_bankAccountForm.accountType.isValid &&
					_bankAccountForm.accountType.isTouched ? (
						<FormHelperText
							id='text-red'
							style={{ margin: '-10px 15px 10px' }}
						>
							{t(_bankAccountForm.accountType.error_text)}
						</FormHelperText>
					) : (
						''
					)}
				</Grid>
			</BaseForm>
		);
	}
}

export default withStyles(commonStyleForEditPersonalInfo)(
	withTranslation()(CreateBankAccountForm)
);
